module.exports = {
  "country": "SE",
  "artist": "Carola",
  "song": "Fangad av en stormvind",
  "year": "1991",
  "place": "1",
  "spotify": "06xX9E1BTTwyOwyaBuszSK"
};